import "./StandardProtocols.scss"
import React from 'react'
import { standardProtocolContent } from '../../SopsData'



function StandardProtocols() {
  return (
    <div className="StandardProtocols">

      <div>
        <h2 className="text-center mt-0 mb-5">Standard Protocol</h2>
      </div>
      <div>
        <ul>
          {standardProtocolContent.map(policy =>
            <li key={policy} className="line-height-4 font-medium">
              {policy}
            </li>)}
        </ul>
      </div>
    </div>
  )
}

export default StandardProtocols